export enum IxActionRight {
    SuperRights,
    DeleteRights,
    EditRights,
    EditBankRights,
    InfoRights,
    NoRightsNeeded,
}

export enum IxModuleRights {
    Super='S',
    All=' ',
    Edit='A',
    Bank='B',
    Info='I',
    Booking='C',
    Exclude='X',
}

export const IxActionRightsMap: { [_: number]: IxModuleRights[] } = {
    [IxActionRight.SuperRights]: [IxModuleRights.Super],
    [IxActionRight.DeleteRights]: [IxModuleRights.All, IxModuleRights.Super, IxModuleRights.Bank, IxModuleRights.Booking],
    [IxActionRight.EditRights]: [IxModuleRights.All, IxModuleRights.Super, IxModuleRights.Edit, IxModuleRights.Bank, IxModuleRights.Booking],
    [IxActionRight.EditBankRights]: [IxModuleRights.All, IxModuleRights.Super, IxModuleRights.Edit],
    [IxActionRight.InfoRights]: [IxModuleRights.All, IxModuleRights.Super, IxModuleRights.Edit, IxModuleRights.Bank, IxModuleRights.Info],
    [IxActionRight.NoRightsNeeded]: [IxModuleRights.All, IxModuleRights.Super, IxModuleRights.Edit, IxModuleRights.Bank, IxModuleRights.Info, IxModuleRights.Booking],
}
